/**
 * Functionality for social sharing dropdown
 */
(function() {
	const nodes = document.getElementsByClassName('social-share');

	for (const node of nodes) {
		const target = node.getElementsByClassName('social-share__target')[0];
		const container = document.getElementById(`${node.getAttribute('data-id')}__container`);

		target.addEventListener('click', () => {
			container.classList.toggle('--show');
			target.classList.toggle('--active');
		});
	}

	window.addEventListener('click', e => {
		for (const node of nodes) {
			const target = node.getElementsByClassName('social-share__target')[0];
			const container = document.getElementById(`${node.getAttribute('data-id')}__container`);
			if (!node.contains(e.target) && !container.contains(e.target)) {
				container.classList.remove('--show');
				target.classList.remove('--active');
			}
		}
	});
})();
